// Ordering for the group + friends standing lists. Shared by both so the two boards
// can never drift apart.
import { getLang } from "./api";

// The setter is not a competitor but the author of the round: they head the list,
// because "today we are guessing THIS person's word" is the first thing it says.
const RANK = { setter: -1, guessed: 0, in_progress: 1, not_started: 2 };
const LOCALE = getLang();

/**
 * Compare two standing rows: solved first (fewest attempts), then players still
 * guessing, then those who haven't started.
 *
 * Players still guessing are ranked by their warmest tip, NOT by attempt count:
 * 8 tips at 90 % is closer to solving than 32 tips at 20 %, so ranking by attempts
 * would put the coldest player on top. Every branch falls through to the name, so
 * rows that tie keep a stable order instead of whatever order the API returned.
 */
export function compareStandings(sa, sb, nameA, nameB) {
  const ra = RANK[sa?.status] ?? 3;
  const rb = RANK[sb?.status] ?? 3;
  if (ra !== rb) return ra - rb;

  if (ra === 0 && sa.attempts !== sb.attempts) return sa.attempts - sb.attempts;

  if (ra === 1) {
    const ba = sa.best_similarity || 0;
    const bb = sb.best_similarity || 0;
    if (ba !== bb) return bb - ba;
    if (sa.attempts !== sb.attempts) return sa.attempts - sb.attempts;
  }

  return (nameA || "").localeCompare(nameB || "", LOCALE, { sensitivity: "base" });
}
